import React, { useState } from 'react';
import {
  Grid, Typography, Box, Button,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/CustomExperienceSection/CustomExperienceSection.styles';
import {
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import dynamic from 'next/dynamic';

const CustomTripDialogV2 = dynamic(() => import('views/rebranded-module/common/components/UI/CustomTripDialogV2').then(
  (file) => file.CustomTripDialogV2,
));

const CustomExperienceSection = (props) => {
  const { serverData: pageData } = props;
  const content = useContent('ToursLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpen = () => setOpenDialog(true);
  const handleClose = () => setOpenDialog(false);

  return (
    <StyledBox>
      <Grid container spacing={8} alignItems="center">
        <Grid item lg={6} xs={12}>
          <Box className="CESGridImgs">
            <Box className="CESMainImg">
              <ImgBox
                image={{
                  src: getSizedImage(content.customExperienceImage1.sizes),
                  alt: content.customExperienceImage1.alt,
                }}
                imgHeight="100%"
                imgWidth="100%"
                imgObjectFit="cover"
                unoptimized
              />
            </Box>
            <Box className="CESSubImg">
              <ImgBox
                image={{
                  src: getSizedImage(content.customExperienceImage2.sizes),
                  alt: content.customExperienceImage2.alt,
                }}
                imgHeight="100%"
                imgWidth="100%"
                imgObjectFit="cover"
                unoptimized
              />
            </Box>
          </Box>
        </Grid>
        <Grid item lg={6}>
          <Box className="CXSContent">
            <Typography700 variant="h2" component="h2" className="CESTitle">
              {content.customExperienceTitle}
            </Typography700>
            <Typography color="text.secondary" variant="body2">
              {content.customExperienceSubtitle}
            </Typography>
            <Button variant="contained" size="large" onClick={handleOpen}>
              {content.customExperienceButtonText}
            </Button>
          </Box>
        </Grid>
      </Grid>
      {openDialog && (
        <CustomTripDialogV2
          content={content}
          pageData={pageData}
          open={openDialog}
          onClose={handleClose}
        />
      )}
    </StyledBox>
  );
};

export { CustomExperienceSection };
